<template>
  <div class="main-box">
    <headers></headers>
    <div class="container_auto all-box">
      <el-row :gutter="24">
        <el-col :span="4" style="padding: 0;" class="left-menu">
          <div class="grid-content bg-purple uc_left_nav" ref="left">
            <left></left>
          </div>
        </el-col>
        <el-col :span="20" class="container right-contain">
          <div class="grid-content bg-purple uc_container_cont" ref="right">
            <positions></positions>
            <router-view class="main-right" />
          </div>
        </el-col>
      </el-row>
      <footers></footers>
    </div>
  </div>
</template>

<script>
import headers from '@/views/common/header' //引入头部
import left from '@/views/common/left' //引入左侧菜单
import footers from '@/views/common/footer' //引入底部
import positions from '@/views/common/position' //引入面包屑导航

import { base64 } from '@/utils'

export default {
  data() {
    return {
      setHeight: 0,
    }
  },
  components: {
    headers, //公共头部
    footers, //公共底部
    positions, //面包屑
    left,
  },
  methods: {
    _setMenuheight() {
      let wh = $(window).height() < 730 ? 730 : $(window).height()
      let oh = $('.main-right>.el-card:last,#customer-box>.el-card:last')[0].offsetTop
      let xh = wh - oh - 162
      $('.main-right>.el-card:last,#customer-box>.el-card:last').css({
        marginBottom: '0',
        minHeight: xh,
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this._setMenuheight()
    })
  },
  watch: {
    $route(nv, ov) {
      this.$nextTick(() => {
        this._setMenuheight()
      })
    },
  },
}
</script>

<style>
html,
body {
  background: #fcfcfc;
  /* min-width: 1300px; */
  margin: auto;
  height: auto;
  min-height: 570px;
}

@media (min-width: 900px) {
  html,
  body {
    min-width: 1300px;
  }
}

.btn-width {
  width: 100%;
  margin-top: 20px !important;
}

/* .main-right {
    min-height: 500px;
  } */

.left-main {
  *zoom: 1;
  clear: both;
}

.uc_left_nav {
  height: 100%;
}

.left-menu {
  position: absolute;
  left: 0;
  height: 100%;
}

.right-contain {
  margin-left: 218px;
}
</style>



// WEBPACK FOOTER //
// src/views/main.vue